module.exports = __webpack_public_path__ + "img/shop2.7bc19afe.jpg";